import Box from "@/common/components/Box";
import ResumeItem from "@/common/components/ResumeItem";
import { MaintenaceWorkflowData } from "@/features/maintenance/features/workflows/types/maintenanceWorkflows.type";
import MaintenanceWorkflowSolicitations from "./components/MaintenanceWorkflowSolicitations";
import { useMemo } from "react";
import { MaintenanceForwardingSectionStyle, maintenanceForwardingSectionStyles } from "@/features/maintenance/features/workflows/constants/forwardings/maintenanceForwardingSectionStyles.constant";
import { cn } from "@/common/utils/cn";

interface MaintenanceDescriptionProps {
  workflow: MaintenaceWorkflowData | undefined;
}

const MaintenanceDescription = ({ workflow }: MaintenanceDescriptionProps) => {
  const sectionStyle = useMemo(() => {
    if (workflow?.status === 'completed') {
      return maintenanceForwardingSectionStyles[MaintenanceForwardingSectionStyle.Completed];
    }

    return maintenanceForwardingSectionStyles[MaintenanceForwardingSectionStyle.Waiting];
  }, [workflow?.status]);

  return (
    <Box className={cn('p-4 flex flex-col gap-4', sectionStyle)}>
      <div className="flex flex-col gap-2">
        <p>
          Solicitações de manutenção
        </p>

        <ResumeItem
          label="Descrição geral do processo"
          value={workflow?.observations || '--'}
          isLoading={!workflow}
          labelClassName="text-xs"
          valueClassName="text-sm"
        />
      </div>

      <MaintenanceWorkflowSolicitations />
    </Box>
  );
}

export default MaintenanceDescription;
